import React from "react";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";

interface PhoneNumberInputProps {
  value: string;
  onChange: any;
  label?: string;
  errors?: boolean;
  errorMessage?: string;
  required?: boolean;
  disabled?: boolean;
  className?: string;
  name?: string;
  placeholder?: string;
}

const PhoneNumberInput: React.FC<PhoneNumberInputProps> = ({
  value,
  onChange,
  label = "Phone Number",
  errors,
  errorMessage,
  required,
  disabled,
  className,
  name,
  placeholder,
}) => {
  const handleChange = (value: string) => {
    onChange({
      target: { name: name || "", value: value }, // Provide a default value for 'name'
    });
  };
  return (
    <div className="form__group">
      <label className={`form__label ${className} ${required ? "endDot" : ""}`}>
        {label}
      </label>
      <PhoneInput
        country={"lk"}
        value={value}
        placeholder={placeholder}
        onChange={handleChange}
        inputClass={`form__field ${errors ? "mandatory_input" : ""}`}
        inputProps={{
          required,
          disabled,
          name: "phoneNumber",
        }}
        enableSearch
      />
      {errors && (
        <label className="form__label__error">
          {errorMessage || `${label} is mandatory`}
        </label>
      )}
    </div>
  );
};

export default React.memo(PhoneNumberInput);
